'use client';

import { cn } from '@/lib/utils';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { Cross2Icon } from '@radix-ui/react-icons';
import { HTMLAttributes, ReactNode, forwardRef } from 'react';
import styles from './dialog.module.scss';

export type DialogProps = {
  open?: boolean;
  defaultOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  modal?: boolean;
  closeOnOutsideClick?: boolean;
  showCloseButton?: boolean;
  forceMount?: boolean;
  children?: ReactNode;
} & HTMLAttributes<HTMLDivElement>;

export const Dialog = forwardRef<HTMLDivElement, DialogProps>(
  (
    {
      children,
      className,
      open,
      defaultOpen,
      onOpenChange,
      modal = true,
      closeOnOutsideClick = true,
      showCloseButton = true,
      forceMount = false,
      ...props
    },
    ref,
  ) => {
    return (
      <DialogPrimitive.Root
        open={open}
        defaultOpen={defaultOpen}
        onOpenChange={onOpenChange}
        modal={modal}
      >
        <DialogPrimitive.Portal>
          <DialogPrimitive.Overlay
            className={styles.component_overlay}
            forceMount={forceMount ? true : undefined}
          />
          <DialogPrimitive.Content
            ref={ref}
            className={cn(styles.component_content, className)}
            onInteractOutside={closeOnOutsideClick ? undefined : (e) => e.preventDefault()}
            onPointerDownOutside={closeOnOutsideClick ? undefined : (e) => e.preventDefault()}
            forceMount={forceMount ? true : undefined}
            {...props}
          >
            {children}
            {showCloseButton && (
              <DialogPrimitive.Close className={styles.component_close} aria-label="Close">
                <Cross2Icon width={24} height={24} />
              </DialogPrimitive.Close>
            )}
          </DialogPrimitive.Content>
        </DialogPrimitive.Portal>
      </DialogPrimitive.Root>
    );
  },
);

Dialog.displayName = 'Dialog';
